import React from 'react';
import { AnswerLogEntry } from './QuizzQuestion';
import useZStore, { getExamples } from '@/utils/useZStore';
import QuizzAnswerReveal from './QuizzAnswerReveal';

interface QuizzAnswersListProps {
  answers: AnswerLogEntry[];
}

const QuizzAnswersList = (props: QuizzAnswersListProps) => {
  const { answers } = props;
  const examples = useZStore(getExamples());

  const reversedAnswers = [...answers].reverse();

  const answersList = reversedAnswers.map((answer) => {
    const example = examples.find((example) => example.id === answer.exampleId);
    if (!example) {
      return null;
    }
    return (
      <QuizzAnswerReveal key={example.id} answer={answer} example={example} />
    );
  });

  if (!answersList.length) {
    return null;
  }

  return (
    <div className="mt-8 w-full px-0 sm:mt-12">
      <h3 className="h4 pb-4 uppercase">Answers</h3>
      <div className="space-y-4">{answersList}</div>
    </div>
  );
};

export default QuizzAnswersList;
